import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import SiteSettings from "../../components/site-settings/site-settings";
import TokenSettingsTable from "../../components/site-settings/token-settings-table";
import FormDefaults from "../../components/site-settings/form-defaults";
import Countries from "../../components/site-settings/countries";

const SiteSettingsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<SiteSettings />}>
          <Route path="facebook-accounts" element={<TokenSettingsTable />} />
          <Route path="form-defaults" element={<FormDefaults />} />
          <Route path="countries" element={<Countries />} />
          <Route index element={<Navigate to="facebook-accounts" replace />} />
          <Route
            path="*"
            element={<Navigate to="facebook-accounts" replace />}
          />
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default SiteSettingsPage;
